export default __webpack_public_path__ + "static/media/cp_geo_re.0bf1dd02.svg";